<template>
  <header
    :class="{ fixed, shadow, shrink: shrinkAfterFirstSlide ? ($store.state.slides.length > 1) : false }"
    :style="{backgroundColor: backgroundColor, height: $store ? $store.getters.getHeaderHeight({mobHeight, height, shrinkAfterFirstSlide, shrinkHeight}) +'px' : height +'px' }"
  >
    <div
      class="header-inner"
      :style="{ height: $store ? $store.getters.getHeaderHeight({mobHeight, height, shrinkAfterFirstSlide, shrinkHeight})+'px' : height + 'px' }"
    >
      <a
        :href="logoLink"
        target="_blank"
        v-if="logoLink"
        class="logo_wrap"
        :style="{ height: $store ? $store.getters.getHeaderHeight({mobHeight, height, shrinkAfterFirstSlide, shrinkHeight})+'px' : height + 'px' }"
      >
        <img class="logo" :src="logo" :alt="logoAlt" />
      </a>
      <div
        class="logo_wrap"
        v-if="!logoLink"
        :style="{ height: $store ? $store.getters.getHeaderHeight({mobHeight, height, shrinkAfterFirstSlide, shrinkHeight})+'px' : height + 'px' }"
      >
        <img
          class="logo"
          :src="logo"
          :alt="logoAlt"
          :style="{ height: $store ? $store.getters.getHeaderHeight({mobHeight, height, shrinkAfterFirstSlide, shrinkHeight})+'px' : height + 'px' }"
        />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "LogoHeader",
  props: {
    fixed: {
      type: Boolean,
      default: true
    },
    backgroundColor: {
      type: String,
      default: "#ffffff"
    },
    height: {
      type: Number,
      default: 100
    },
    mobHeight: {
      type: Number,
      default: 70
    },
    logo: {
      type: String,
      default: require("../../assets/logo.svg")
    },
    logoAlt: {
      type: String,
      default: "Forward Action Logo"
    },
    logoLink: {
      type: String,
      default: ""
    },
    shadow: {
      type: Boolean,
      default: true
    },
    shrinkAfterFirstSlide: {
      type: Boolean,
      default: false
    },
    shrinkHeight: {
      type: Number,
      default: 60
    }
  }
};
</script>

<style lang="scss" scoped>
header {
  background-color: #ffffff;
  transition: 0.25s;

  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }

  &.shrink {
    .header-inner {
      .logo_wrap {
        padding: 0 0;
      }
    }
  }

  &.shadow {
    box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.11);
  }
}
.header-inner {
  width: 100%;
  max-width: 1225px;
  padding: 0 20px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  transition: 0.25s;
  @media (max-width: 767px) {
    height: 60px;
    padding: 0;
  }
}
.logo_wrap {
  padding: 0;
  display: flex;
  align-items: center;
  transition: 0.25s;
}
.logo {
  width: auto;
  max-height: 100%;
  transition: 0.25s;
  @media (max-width: 767px) {
    width: auto;
  }
}
</style>